import '../inbox_content_view.js.coffee';# Added by Script 
import '../social_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.InstagramMediaMessageView extends Monitoring.Views.SocialContents.InboxContentView

  _renderAttachments: ->
    attachments = @model.getAttachments()
    instagramAttachments = _.object(
      ["#{type}s", @_getAttachments(attachments, type)] for type in ['image', 'video', 'audio', 'file']
    )
    @attachmentsView = new Monitoring.Views.SocialContents.SocialContentAttachmentsView
      instagramAttachments: instagramAttachments
      useVideoIcon: instagramAttachments.videos.length > 0
    @$el.find('.sc-text').append(@attachmentsView.render().el)

  _getAttachments: (attachments, type) ->
    _.select(attachments, (attachment) -> attachment.type == type)

  _showAttachmentsBox: ->
    true
